import React from 'react';
import { Header } from '../components/Header';
import { BirthdayParties } from '../components/BirthdayParties';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';
import { motion } from 'framer-motion';
import { CakeIcon, SparklesIcon, PhoneIcon, ArrowRightIcon, MapPinIcon } from 'lucide-react';
export function BirthdayPartiesPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-462">
      <Header data-id="element-463" />
      <main data-id="element-464">
        {/* Birthday Hero */}
        <section className="relative bg-navy-950 overflow-hidden pt-16 pb-14 md:pt-24 md:pb-20" data-id="element-465">
          <div className="absolute inset-0 pointer-events-none" data-id="element-466">
            <div className="absolute top-0 right-0 w-96 h-96 bg-amber/10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-467" />
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-navy-700/40 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3" data-id="element-468" />
          </div>

          <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-469">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="flex justify-center mb-6" data-id="element-470">
              <div className="w-16 h-16 bg-amber/20 rounded-2xl flex items-center justify-center border border-amber/30 backdrop-blur-sm" data-id="element-471">
                <CakeIcon className="w-8 h-8 text-amber" data-id="element-472" />
              </div>
            </motion.div>

            <motion.h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white font-heading mb-6" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} data-id="element-473">
              Martial Arts Birthday Parties for{' '}
              <span className="text-amber" data-id="element-474">Colleyville-Area Kids</span>
            </motion.h1>

            <motion.p className="text-lg sm:text-xl text-white/80 leading-relaxed max-w-2xl mx-auto" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-475">
              Action-packed, instructor-led birthday parties at our Hurst
              academy. We handle the fun, setup, food and cleanup — you enjoy
              the day.
            </motion.p>

            <motion.p className="mt-3 flex items-center justify-center gap-2 text-sm text-white/50" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.25
          }} data-id="element-476">
              <MapPinIcon className="w-4 h-4 text-amber/70 shrink-0" data-id="element-477" />
              Hosted at 750 Grapevine Hwy, Hurst, TX 76054
            </motion.p>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber/20 to-transparent" data-id="element-478" />
        </section>

        {/* Pricing Section */}
        <BirthdayParties data-id="element-479" />

        {/* What to Expect Section */}
        <section className="py-16 md:py-24 bg-warm-50 border-t border-warm-200" data-id="element-480">
          <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-481">
            <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-482">
              <h2 className="text-3xl font-extrabold text-navy-950 font-heading tracking-tight mb-4" data-id="element-483">
                What to Expect
              </h2>
              <p className="text-lg text-ink-muted" data-id="element-484">
                Every party at NTA is designed to make the birthday child feel
                like a star while keeping all the guests engaged and active.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-485">
              <div className="bg-white p-8 rounded-2xl border border-warm-200 shadow-sm text-center" data-id="element-486">
                <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center mx-auto mb-5" data-id="element-487">
                  <SparklesIcon className="w-6 h-6 text-amber-dark" data-id="element-488" />
                </div>
                <h3 className="text-lg font-bold text-navy-950 mb-3" data-id="element-489">
                  Zero Hassle
                </h3>
                <p className="text-sm text-ink-muted leading-relaxed" data-id="element-490">
                  From setup to cleanup, our staff handles everything. You can
                  actually relax, take photos, and enjoy your child's special
                  day.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-warm-200 shadow-sm text-center" data-id="element-491">
                <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center mx-auto mb-5" data-id="element-492">
                  <SparklesIcon className="w-6 h-6 text-amber-dark" data-id="element-493" />
                </div>
                <h3 className="text-lg font-bold text-navy-950 mb-3" data-id="element-494">
                  Action-Packed
                </h3>
                <p className="text-sm text-ink-muted leading-relaxed" data-id="element-495">
                  Kids burn off energy with fun martial arts drills, games, and
                  activities led by our enthusiastic professional instructors.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-warm-200 shadow-sm text-center" data-id="element-496">
                <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center mx-auto mb-5" data-id="element-497">
                  <SparklesIcon className="w-6 h-6 text-amber-dark" data-id="element-498" />
                </div>
                <h3 className="text-lg font-bold text-navy-950 mb-3" data-id="element-499">
                  Board Breaking
                </h3>
                <p className="text-sm text-ink-muted leading-relaxed" data-id="element-500">
                  The highlight of the party! The birthday child gets to break a
                  real wooden board in front of all their friends.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Birthday-Specific CTA (NOT the martial arts free week CTA) */}
        <section className="relative bg-navy-950 overflow-hidden" data-id="element-501">
          <div className="absolute inset-0 pointer-events-none" data-id="element-502">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber/5 rounded-full blur-3xl" data-id="element-503" />
            <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-navy-700/20 rounded-full blur-3xl" data-id="element-504" />
          </div>

          <div className="relative max-w-3xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center" data-id="element-505">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5
          }} data-id="element-506">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white font-heading tracking-tight" data-id="element-507">
                Book Your Child's Birthday Party
              </h2>
              <p className="mt-5 text-lg text-white/70 leading-relaxed max-w-xl mx-auto" data-id="element-508">
                Packages start at $299. Call us to check availability and
                reserve your preferred date.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-509">
                <a href="tel:817-581-1419" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-amber text-navy-950 font-bold text-base rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2 focus:ring-offset-navy-950 w-full sm:w-auto" data-id="element-510">
                  <PhoneIcon className="w-4 h-4" data-id="element-511" />
                  Call to Book: 817-581-1419
                </a>
                <a href="#cta" className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white/20 text-white font-semibold text-base rounded-lg hover:border-white/40 hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-white/30 focus:ring-offset-2 focus:ring-offset-navy-950 w-full sm:w-auto" data-id="element-512">
                  Ask About Available Dates
                  <ArrowRightIcon className="w-4 h-4" data-id="element-513" />
                </a>
              </div>
            </motion.div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber/20 to-transparent" data-id="element-514" />
        </section>
      </main>
      <Footer data-id="element-515" />
      <MobileStickyCTA data-id="element-516" />
      <div className="h-[72px] md:hidden" data-id="element-517" />
    </div>;
}